import { Grid, Divider } from "@mui/material";
import { useSelector } from "react-redux";

import { Navbar } from "./Navbar";
import SelectRole from "./SelectRole";

export default function AdminLandingPage() {
  const { authToken, userID, businessEntityId, brands } = useSelector(
    (state) => state.memberDetails
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Navbar />
      </Grid>

      <Grid item xs={12} style={{ padding: "0 50px" }}>
        {/* <Divider /> */}
      </Grid>

      <Grid item xs={12} style={{ paddingTop: "0px" }}>
        <SelectRole
          brands={brands}
          businessEntityID={businessEntityId}
          authToken={authToken}
          userID={userID}
          component="admin"
        />
      </Grid>
    </Grid>
  );
}
